import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTour_Sidebar extends Component {
  render() {
    const { location } = this.props;
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <a href="/apps/cityx-tour-pass">
                    <span className="text">CityX Tour&#38;Pass</span>
                  </a>
                </li>

                <li className="list-item">
                  <a href="/apps/cityx-tour-pass-tourist-guides">
                    <span className="text">Turistički vodiči</span>
                  </a>
                </li>

                <li className="list-item">
                  <a href="/apps/cityx-tour-pass-museums">
                    <span className="text">Muzeji, galerije...</span>
                  </a>
                </li>
                <li className="list-item">
                  <a href="/apps/cityx-tour-pass-promotions">
                    <span className="text">Promocije</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="widget widget_help align-center has-shadow no-sep has-border border-solid">
            <div className="inner">
              <h2 className="widget-title margin-bottom-14">
                <span>Kako Vam mogu pomoći?</span>
              </h2>
              <p className="text line-height-26 margin-bottom-23">
                <img
                  src="../assets/img/employees/martina.jpeg"
                  alt="Katarina Babić, CityX Apps"
                />
                <br />
                <br />
                Kako bi postali partner aplikacije CityX Tour &#38; Pass,
                obratite se <b>Martini Šahbaz</b>.
              </p>
              <div className="elm-button">
                <a href="/contact" className="themesflat-button bg-accent pd30">
                  KONTAKTIRAJTE ME
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default CityXTour_Sidebar;
